





























import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import { ContextState, User, Config, EditUserData } from '@/store/context/contextTypes'
import { hasProperty } from '@/utils/helpers'
import { constructDIDProviderUrl } from '@/utils/didHelpers'
import FormInput from '@/components/FormInput.vue'
import GetIdentifyData from '@/utils/identifyFields/countries'
import JavascriptAPI from '@/utils/JavascriptAPI'

const _CONTEXT_: string = 'context'

@Component({
  computed: {
    ...mapState({
      user: (state: any): any => state.context.user,
      editUserData: (state: any): EditUserData => state.context.editUserData,
      config: (state: any): User => state.context.config,
      editUserErrors: (state: any): User => state.context.editUserErrors
    })
  },
  components: {
    FormInput
  }
})
export default class EditUser extends Vue {
  user?: User
  config: Config
  editUserData: EditUserData
  userEditFields: Array<object>
  editUserErrors: object
  @State('context') context: ContextState
  @Action('setEditUserData', { namespace: _CONTEXT_ }) setEditUserData: any

  beforeMount () {
    // We assign this to local state since we don't need to filter+sort all available fields based on config more than once
    this.userEditFields = this.identifyFields
  }

  mounted () {
    setTimeout(() => {
      JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
    }, 50)
  }

  // If we're doing a manual register - auto complete the entire form from saved user info in the browser
  // But when editing an identified user - if we turn on autocomplete for the form, the existing info will be overwritten
  get shouldAutoComplete (): boolean {
    return this.user === undefined
  }

  // computed
  get identifyFields (): Array<object> {
    const { country } = this.config
    return GetIdentifyData[country](null, true).fields
  }

  get editUserFields () {
    return this.userEditFields
  }

  // Do we have an registered error for the field id?
  isValid (input) {
    return !hasProperty(this.editUserErrors, input.id)
  }

  handleInputChange (e, fieldIndex) {
    this.setEditUserData({ key: e.target.id, value: e.target.value })
  }
}
